import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Typography,
  Stack,
  Button,
  IconButton,
  Divider,
  Avatar,
  Dialog,
  DialogContent,
  TextField,
  Checkbox,
  FormControlLabel,
  Menu,
  MenuItem,
  Tooltip,
  CircularProgress,
  Modal,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import PublishIcon from '@mui/icons-material/Publish';
import SendOutlinedIcon from "@mui/icons-material/SendOutlined";
import { isMobile } from "react-device-detect";
import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import AutoGraphOutlinedIcon from "@mui/icons-material/AutoGraphOutlined";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
import FolderOutlinedIcon from "@mui/icons-material/FolderOutlined";
import SmartToyOutlinedIcon from "@mui/icons-material/SmartToyOutlined";
import TrendingUpOutlinedIcon from "@mui/icons-material/TrendingUpOutlined";
import PaymentOutlinedIcon from "@mui/icons-material/PaymentOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import TwitterIcon from "@mui/icons-material/Twitter";
import FacebookIcon from "@mui/icons-material/Facebook";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import FilterListIcon from "@mui/icons-material/FilterList";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import PublishOutlinedIcon from "@mui/icons-material/PublishOutlined";
import ThumbUpOutlinedIcon from "@mui/icons-material/ThumbUpOutlined";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import NearMeOutlinedIcon from "@mui/icons-material/NearMeOutlined";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import RocketLaunchOutlinedIcon from "@mui/icons-material/RocketLaunchOutlined";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import YouTubeIcon from "@mui/icons-material/YouTube";
import MicNoneOutlinedIcon from '@mui/icons-material/MicNoneOutlined';
import { toast } from "react-toastify";
import ComingSoonPopup from "../../../components/ComingSoonPopup";

const apiUrl: string = process.env.REACT_APP_SERVER_ENDPOINT || "";
const returndomain: string = process.env.REACT_APP_RETURN_DOMAIN_NAME || "";

const bottomNav = [
  { id: "upgrade", label: "Upgrade", icon: <TrendingUpOutlinedIcon sx={{ fontSize: 18 }} /> },
  { id: "billing", label: "Billing", icon: <PaymentOutlinedIcon sx={{ fontSize: 18 }} /> },
  { id: "settings", label: "Settings", icon: <SettingsOutlinedIcon sx={{ fontSize: 18 }} /> },
  { id: "logout", label: "Logout", icon: <LogoutOutlinedIcon sx={{ fontSize: 18 }} /> },
];

const recentComments = [
  { id: 1, initials: "B", name: "Brian R.", text: "This makes, a ton of sense. foreat post, Roham." },
  { id: 2, initials: "A", name: "Anna", text: "This makes, a ton of sense. foreat post, Roham." },
  { id: 3, initials: "B", name: "Brian R.", text: "I never thought of Substack switching to OCESha this way" },
  { id: 4, initials: "IG", name: "IG User", text: "Completely agree. SEO is dead." },
  { id: 5, initials: "V", name: "V", text: "This makes, a ton of sense. foreat post, Roham." },
];

// Connection chip configuration — matches PublishScheduleClip styling
type ConnectablePlatform = "linkedin" | "twitter" | "facebook" | "youtube";

const CONNECTABLE_PLATFORMS: {
  id: ConnectablePlatform;
  label: string;
  shortLabel: string;
  icon: React.ReactNode;
  brandColor: string;
}[] = [
    { id: "linkedin", label: "LinkedIn", shortLabel: "LinkedIn", icon: <LinkedInIcon sx={{ fontSize: 18 }} />, brandColor: "#0a66c2" },
    { id: "twitter", label: "X (Twitter)", shortLabel: "X", icon: <TwitterIcon sx={{ fontSize: 18 }} />, brandColor: "#4BA5EB" },
    { id: "facebook", label: "Facebook", shortLabel: "Facebook", icon: <FacebookIcon sx={{ fontSize: 18 }} />, brandColor: "#1877f2" },
    { id: "youtube", label: "YouTube", shortLabel: "YouTube", icon: <YouTubeIcon sx={{ fontSize: 18 }} />, brandColor: "#FF0000" },
  ];

const PlatformChip = ({ platform }: { platform: string }) => {
  type Cfg = { icon: React.ReactNode; label: string; color: string; background: string; gradient?: string; };
  const map: Record<string, Cfg> = {
    linkedin: { icon: <LinkedInIcon sx={{ fontSize: 15, color: "#0A66C2" }} />, label: "LinkedIn", color: "#f3e0e0a5", background: "transparent" },
    facebook: { icon: <FacebookIcon sx={{ fontSize: 15, color: "#1877F2" }} />, label: "Facebook", color: "#f3e0e0a5", background: "transparent" },
    twitter: { icon: <TwitterIcon sx={{ fontSize: 15, color: "#1DA1F2" }} />, label: "Twitter", color: "#f3e0e0a5", background: "transparent" },
    youtube: { label: "YouTube", icon: <YouTubeIcon sx={{ fontSize: 16 }} />, gradient: "linear-gradient(90deg, #FF0000, #cc0000)", color: "#fff", background: "transparent" },
  };
  const p = map[platform];
  if (!p) return null;
  return (
    <Box sx={{ display: "inline-flex", alignItems: "center", gap: "5px", px: "10px", py: "4px", borderRadius: "6px", border: `1px solid ${p.color}`, background: "transparent", mr: "8px", userSelect: "none" }}>
      {p.icon}
      <Typography sx={{ fontSize: "12px", fontWeight: 500, color: p.color, lineHeight: 1 }}>{p.label}</Typography>
    </Box>
  );
};

function getLocalOffset() {
  const offset = -new Date().getTimezoneOffset();
  const sign = offset >= 0 ? "+" : "-";
  const hours = String(Math.floor(Math.abs(offset) / 60)).padStart(2, "0");
  const minutes = String(Math.abs(offset) % 60).padStart(2, "0");
  return `${sign}${hours}:${minutes}`;
}

function formatToLocal(dateString?: any) {
  if (!dateString) return "";
  const date = new Date(dateString);
  return date.toLocaleString(undefined, { year: "numeric", month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" });
}

function toDateTimeLocal(dateString: string | Date) {
  if (!dateString) return "";
  const date = new Date(dateString);
  const pad = (n: number) => String(n).padStart(2, "0");
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
}

interface LoadingStates { [key: string]: boolean; }

// =============================================================================
const SocialPost: React.FC = () => {
  const navigate = useNavigate();
  const [active, setActive] = useState("contentlibrary");
  const recognitionRef = useRef<any>(null);
  const [isListening, setIsListening] = useState(false);

  const [comingSoonOpen, setComingSoonOpen] = useState(false);
  const [comingSoonPlatform, setComingSoonPlatform] = useState("");

  const [selectedPosts, setSelectedPosts] = useState<string[]>([]);
  const [isBulkDeleting, setIsBulkDeleting] = useState(false);
  const [bulkDeleteModal, setBulkDeleteModal] = useState(false);


  // ── OAuth return redirect (checked synchronously during initial mount) ────
  // If the user started an OAuth flow from another page (e.g. PublishScheduleClip),
  // that page stashed sessionStorage.oauth_return before redirecting. We detect
  // that on mount and bounce them back to where they came from, restoring the
  // React Router navigation state that was lost during the OAuth round trip.
  const [oauthRedirecting] = useState<boolean>(() => {
    try {
      const raw = sessionStorage.getItem("oauth_return");
      if (!raw) return false;
      const payload = JSON.parse(raw);
      // Ignore stale entries (older than 10 minutes — likely abandoned flow)
      const age = Date.now() - (payload?.timestamp || 0);
      if (age > 10 * 60 * 1000) {
        sessionStorage.removeItem("oauth_return");
        return false;
      }
      // Don't redirect if we're already on the target path (avoid loops)
      if (!payload?.path || payload.path === window.location.pathname) {
        sessionStorage.removeItem("oauth_return");
        return false;
      }
      return true;
    } catch {
      sessionStorage.removeItem("oauth_return");
      return false;
    }
  });

  // Perform the OAuth-return redirect right after first render.
  useEffect(() => {
    if (!oauthRedirecting) return;
    const raw = sessionStorage.getItem("oauth_return");
    if (!raw) return;
    try {
      const payload = JSON.parse(raw);
      // Carry along the connection-success query params (?linkedin=connected, etc.)
      // so the destination page's existing detection logic can show its toast.
      const search = window.location.search;
      sessionStorage.removeItem("oauth_return");
      navigate(payload.path + search, {
        state: payload.state,
        replace: true,
      });
    } catch {
      sessionStorage.removeItem("oauth_return");
    }
  }, [oauthRedirecting, navigate]);

  // ── State (all declared before any handlers) ─────────────────────────────
  const [authStatus, setAuthStatus] = useState<any>({ linkedin: false, twitter: false, facebook: false });
  const [connectionDetails, setConnectionDetails] = useState<Record<string, any>>({});
  const [connectingPlatform, setConnectingPlatform] = useState<ConnectablePlatform | null>(null);
  const [hoveredChip, setHoveredChip] = useState<ConnectablePlatform | null>(null);
  const [openModal, setOpenModal] = useState(false);
  const [stats, setStats] = useState({ total: 0, published: 0, pending: 0 });
  const [postData, setPostData] = useState({
    content: "", url: "", video_url: "", scheduleTime: "",
    platforms: { linkedin: false, twitter: false, facebook: false },
    imageFile: null as File | null,
  });
  const [posts, setPosts] = useState<any[]>([]);
  const [isEditMode, setIsEditMode] = useState(false);
  const [editingPostId, setEditingPostId] = useState<string | null>(null);
  const [existingImage, setExistingImage] = useState<string | null>(null);
  // Twitter is now enabled — no platforms are disabled in the modal.
  const disabledPlatforms: string[] = [];
  const [page, setPage] = useState(1);
  const [limit] = useState(5);
  const [total, setTotal] = useState(0);
  const [search, setSearch] = useState("");
  const [filter, setFilter] = useState("all");
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [isPublishLoading, setIsPublishLoading] = useState<LoadingStates>({});
  const [isTwitterPublishLoading, setIsTwitterPublishLoading] = useState<LoadingStates>({});

  // ── Shared styles ─────────────────────────────────────────────────────────
  const inputStyle = {
    mb: 0,
    "& .MuiOutlinedInput-root": {
      background: "transparent", borderRadius: "10px", boxShadow: "inset 0 1px 2px rgba(0,0,0,0.4)",
      "& fieldset": { borderColor: "rgba(255,255,255,0.08)" },
      "&:hover fieldset": { borderColor: "#4BA5EB" },
      "&.Mui-focused fieldset": { borderColor: "#4BA5EB", boxShadow: "0 0 8px rgba(75,165,235,0.5)" },
    },
    input: { color: "#000" },
    textarea: { color: "#000" },
  };

  const fieldLabelStyle = { fontSize: "13px", fontWeight: 500, color: '#000', mb: "6px" };

  // ── Helpers ───────────────────────────────────────────────────────────────
  const normalizeImageUrl = (url: string) => {
    if (!url) return "";
    if (url.startsWith("https//")) url = url.replace("https//", "https://");
    if (url.startsWith("http")) return url;
    return `${apiUrl}${url}`;
  };

  function buildScheduleTime(dateTimeLocal: string) {
    if (dateTimeLocal.includes(":")) {
      return `${dateTimeLocal.length === 16 ? dateTimeLocal + ":00" : dateTimeLocal}${getLocalOffset()}`;
    }
    return dateTimeLocal;
  }

  // ── API calls ─────────────────────────────────────────────────────────────
  const fetchAuthStatus = async () => {
    try {
      const userEmail = localStorage.getItem("user_email") || "";
      const { data } = await axios.get(`${apiUrl}/api/socialmedia/api/auth-status`, {
        params: { user_email: userEmail },
        withCredentials: true,
      });
      setAuthStatus(data.status || {});
      if (data.details) setConnectionDetails(data.details);
    } catch (err) { console.error("Failed to fetch auth status", err); }
  };

  const fetchStats = async () => {
    try {
      const userEmail = localStorage.getItem("user_email") || "";
      const { data } = await axios.get(`${apiUrl}/api/socialmedia/api/posts/stats`, {
        params: { user_email: userEmail },
        withCredentials: true,
      });
      setStats({ total: data.total, published: data.published, pending: data.pending });
    } catch (err) { console.error("Failed to fetch stats", err); }
  };

  const fetchPosts = async () => {
    try {
      setLoading(true);
      const userEmail = localStorage.getItem("user_email") || "";
      const { data } = await axios.get(`${apiUrl}/api/socialmedia/api/posts`, {
        params: { page, limit, status: filter, search: debouncedSearch, user_email: userEmail },
        withCredentials: true,
      });
      setPosts(data.data);
      setTotal(data.total);
    } catch (err) { console.error(err); }
    finally { setLoading(false); }
  };

  const handleDisconnect = async (platform: ConnectablePlatform) => {
    if (!window.confirm(`Disconnect ${platform}?`)) return;
    try {
      await axios.post(`${apiUrl}/api/socialmedia/api/auth/disconnect/${platform}`);
      toast.success(`${platform} disconnected.`);
      fetchAuthStatus();
    } catch (err: any) {
      console.error("Disconnect failed", err);
      const detail = err?.response?.data?.detail || "Disconnect failed";
      toast.error(detail);
    }
  };

  // Connect a platform via OAuth.
  // Stash the current path before redirecting so we land back here afterward.
  const handleConnect = async (platform: ConnectablePlatform) => {
    setConnectingPlatform(platform);
    try {
      sessionStorage.setItem(
        "oauth_return",
        JSON.stringify({
          path: window.location.pathname,
          state: null, // SocialPost doesn't rely on navState
          platform,
          timestamp: Date.now(),
        })
      );

      const email = localStorage.getItem("user_email");
      const { data } = await axios.get(`${apiUrl}/api/socialmedia/auth/${platform}`, {
        params: { user_email: email },
        withCredentials: true,
      });
      if (data?.auth_url) {
        window.location.href = data.auth_url;
      } else {
        toast.error(`Could not start ${platform} authentication.`);
        setConnectingPlatform(null);
        sessionStorage.removeItem("oauth_return");
      }
    } catch (err: any) {
      console.error("Connect error:", err);
      const detail = err?.response?.data?.detail || err?.message || "Connection failed";
      toast.error(`${platform}: ${detail}`);
      setConnectingPlatform(null);
      sessionStorage.removeItem("oauth_return");
    }
  };

  // ── Action handlers ───────────────────────────────────────────────────────
  const handleViewClick = (post: any) => {
    const url = post.url || post.post_url || '';
    if (url) window.open(url, '_blank');
    else alert("No URL available for this post");
  };

  const handleEditClick = (post: any) => {
    setIsEditMode(true);
    setEditingPostId(post.id);
    setExistingImage(post.image_url || null);
    setPostData({
      content: post.content || '',
      url: post.url || '',
      video_url: post.video_url || '',
      scheduleTime: post.schedule_time ? toDateTimeLocal(post.schedule_time) : '',
      platforms: {
        linkedin: post.platform === 'linkedin',
        twitter: post.platform === 'twitter',
        facebook: post.platform === 'facebook',
      },
      imageFile: null,
    });
    setOpenModal(true);
  };

  const handleDeleteClick = async (postId: string) => {
    if (!window.confirm('Are you sure you want to delete this post?')) return;
    try {
      await axios.post(
        `${apiUrl}/api/socialmedia/api/posts/${postId}/delete`,
        null,
        { withCredentials: true }
      );
      // fetchPosts();
      // fetchStats();
      setTimeout(() => {
        navigate(0);
      }, 1200);
    } catch (err) { console.error('Delete failed', err); toast.error('Failed to delete post'); }
  };

  const handlePublishIconClick = async (post: any) => {
    const postId = post.id;
    setIsPublishLoading((prev) => ({ ...prev, [postId]: true }));
    try {
      navigate('/ocesha/publish-schedule-clip', {
        state: {
          postContent: post.content || '',
          postId: post.id || '',
          clipTitle: post.content?.substring(0, 60) || '',
          clipThumbnail: post.image_url || '',
          platform: post.platform || 'twitter',
          blogId: post.blog_id || '',
          scheduleTime: post.schedule_time || '',   // ← pass existing schedule time
          sourceType: 'socialpost',
        },
      });
    } catch (error) {
      console.error('Error in handlePublishIconClick:', error);
    } finally {
      setIsPublishLoading((prev) => ({ ...prev, [postId]: false }));
    }
  };

  const handlePublishTwitterNow = async (post: any) => {
    if (!post?.id) return;
    if (!window.confirm("Publish this tweet now?")) return;
    const postId = post.id;
    setIsTwitterPublishLoading((prev) => ({ ...prev, [postId]: true }));
    try {
      const { data } = await axios.post(
        `${apiUrl}/api/socialmedia/api/posts/${postId}/publish-twitter`
      );
      toast.success(data?.message || "Tweet published");
      fetchPosts();
      fetchStats();
    } catch (err: any) {
      console.error("Twitter publish failed:", err);
      const detail = err?.response?.data?.detail || "Failed to publish tweet";
      toast.error(typeof detail === "string" ? detail : "Failed to publish tweet");
    } finally {
      setIsTwitterPublishLoading((prev) => ({ ...prev, [postId]: false }));
    }
  };

  const publishTwitterImmediate = async (content: string, imageUrl: string | null) => {
    const { data } = await axios.post(`${apiUrl}/api/socialmedia/api/post/twitter`, {
      content,
      imageUrl,
    });
    return data;
  };

  const handleSubmitPost = async () => {
    try {
      const selectedPlatforms = Object.entries(postData.platforms).filter(([_, v]) => v).map(([k]) => k);
      if (selectedPlatforms.length === 0) { toast.error("Select at least one platform"); return; }

      const twitterOnly = selectedPlatforms.length === 1 && selectedPlatforms[0] === "twitter";
      const wantsImmediate = twitterOnly && !postData.scheduleTime;

      if (!wantsImmediate) {
        if (!postData.scheduleTime) { toast.error("Please select a schedule time"); return; }
        // In edit mode, allow keeping an existing (possibly past) schedule time unchanged
        if (!isEditMode && new Date(postData.scheduleTime) < new Date()) {
          toast.error("Cannot schedule in the past"); return;
        }
      }

      let imageUrl: string | null = null;
      if (postData.imageFile) {
        const fd = new FormData(); fd.append("file", postData.imageFile);
        const uploadRes = await axios.post(`${apiUrl}/api/socialmedia/api/upload`, fd, { withCredentials: true });
        imageUrl = uploadRes.data.url;
      }

      if (wantsImmediate) {
        try {
          const data = await publishTwitterImmediate(postData.content, imageUrl);
          toast.success(data?.message || "Tweet published successfully");
        } catch (err: any) {
          const detail = err?.response?.data?.detail || "Failed to publish tweet";
          toast.error(typeof detail === "string" ? detail : "Failed to publish tweet");
          return;
        }
        setOpenModal(false);
        setIsEditMode(false);
        setEditingPostId(null);
        setExistingImage(null);
        fetchPosts();
        fetchStats();
        return;
      }

      const scheduleTimeWithTZ = buildScheduleTime(postData.scheduleTime);

      if (isEditMode && editingPostId) {
        const userEmail = localStorage.getItem("user_email") || "";
        await axios.post(
          `${apiUrl}/api/socialmedia/api/posts/${editingPostId}/update`,
          {
            content: postData.content,
            platform: selectedPlatforms[0],
            scheduleTime: scheduleTimeWithTZ,
            imageUrl: imageUrl || existingImage,
            url: postData.url,
            video_url: postData.video_url,
            user_email: userEmail,
          },
          { withCredentials: true }
        );
        toast.success("Post updated successfully");
      } else {
        await Promise.all(selectedPlatforms.map((platform) =>
          axios.post(
            `${apiUrl}/api/socialmedia/api/schedule-post`,
            {
              content: postData.content,
              platform,
              scheduleTime: scheduleTimeWithTZ,
              imageUrl,
              url: postData.url,
              video_url: postData.video_url,
            },
            { withCredentials: true }
          )
        ));
        toast.success("Post scheduled successfully");
      }

      setOpenModal(false);
      setIsEditMode(false);
      setEditingPostId(null);
      setExistingImage(null);
      fetchPosts();
      fetchStats();
    } catch (err) { console.error(err); toast.error("Failed to submit post"); }
  };

  // ── Speech recognition ────────────────────────────────────────────────────
  const createSpeechRecognition = (onFinal: (text: string) => void, setListen: (v: boolean) => void) => {
    if (!("webkitSpeechRecognition" in window)) { console.warn("Speech recognition not supported"); return null; }
    const r = new (window as any).webkitSpeechRecognition();
    r.continuous = true; r.interimResults = true; r.lang = "en-US";
    r.onresult = (event: any) => {
      let final = "";
      for (let i = event.resultIndex; i < event.results.length; i++) {
        if (event.results[i].isFinal) final += event.results[i][0].transcript;
      }
      if (final) onFinal(final);
    };
    r.onend = () => setListen(false);
    r.onerror = () => setListen(false);
    return r;
  };

  const handleMic = async (ref: React.RefObject<any>, listening: boolean, setListen: (v: boolean) => void) => {
    if (!ref.current) return;
    if (listening) { ref.current.stop(); setListen(false); return; }
    try {
      if (!navigator.mediaDevices?.getUserMedia) return;
      await navigator.mediaDevices.getUserMedia({ audio: true });
      ref.current.start(); setListen(true);
    } catch (err) { console.error("Mic error", err); }
  };

  // ── Effects ───────────────────────────────────────────────────────────────
  useEffect(() => {
    recognitionRef.current = createSpeechRecognition(
      (text) => setPostData((prev) => ({ ...prev, content: (prev.content + " " + text).trim() })),
      setIsListening
    );
  }, []);

  useEffect(() => {
    // Skip data fetching if we're about to redirect away — saves wasted API calls.
    if (oauthRedirecting) return;
    fetchAuthStatus();
    fetchStats();
  }, [oauthRedirecting]);

  useEffect(() => {
    if (oauthRedirecting) return;
    fetchPosts();
    setSelectedPosts([]);
  }, [page, filter, debouncedSearch, oauthRedirecting]);

  useEffect(() => {
    const t = setTimeout(() => setDebouncedSearch(search), 400);
    return () => clearTimeout(t);
  }, [search]);

  // Detect ?platform=connected on return from the OAuth callback
  useEffect(() => {
    if (oauthRedirecting) return; // skip if redirecting away
    const params = new URLSearchParams(window.location.search);
    const platforms: ConnectablePlatform[] = ["linkedin", "twitter", "facebook"];
    let detected: ConnectablePlatform | null = null;
    for (const p of platforms) {
      if (params.get(p) === "connected") {
        detected = p;
        break;
      }
    }
    if (detected) {
      const label = CONNECTABLE_PLATFORMS.find(p => p.id === detected)?.label || detected;
      toast.success(`Successfully connected!`);
      fetchAuthStatus();
      params.delete(detected);
      const newSearch = params.toString();
      const newUrl = window.location.pathname + (newSearch ? `?${newSearch}` : '');
      window.history.replaceState({}, document.title, newUrl);
    }
  }, [oauthRedirecting]);

  // ── Navigation helper ─────────────────────────────────────────────────────
  const isAnyConnected = Object.values(authStatus).some(Boolean);

  const go = (id: string) => {
    setActive(id);
    if (id === "mycourse") navigate("/codegenie/generated-courses");
    else if (id === "dashboard") navigate("/codegenie/generated-blogs");
    else if (id === "createcontent") navigate("/codegenie/new-podcast");
    else if (id === "authority") navigate("/codegenie/authority-engine");
  };

  const visiblePostIds = posts.map(
    (post: any) => post._id || post.id
  );

  const allSelected =
    visiblePostIds.length > 0 &&
    visiblePostIds.every((id) =>
      selectedPosts.includes(id)
    );

  const handleSelectAllPosts = () => {
    if (allSelected) {
      setSelectedPosts([]);
    } else {
      setSelectedPosts(visiblePostIds);
    }
  };

  const handleBulkDeletePosts = async () => {
    if (selectedPosts.length === 0) return;

    /*if (
      !window.confirm(
        `Delete ${selectedPosts.length} selected posts?`
      )
    ) {
      return;
    }*/

    try {
      setIsBulkDeleting(true);

      await axios.post(
        `${apiUrl}/api/socialmedia/api/posts/delete_posts_multipe?post_ids=${selectedPosts.join(",")}`,
        null,
        {
          headers: {
            accept: "application/json",
          },
        }
      );

      toast.success("Posts deleted successfully");

      // setSelectedPosts([]);

      // fetchPosts();
      // fetchStats();
      setTimeout(() => {
        navigate(0);
      }, 1200);
    } catch (error) {
      console.error(error);
      toast.error("Failed to delete posts");
    } finally {
      setIsBulkDeleting(false);
    }
  };

  // ── Render connection chip ───────────────────────────────────────────────
  const renderConnectChip = (p: typeof CONNECTABLE_PLATFORMS[number]) => {
    const isConnected = !!authStatus?.[p.id];
    const isConnecting = connectingPlatform === p.id;
    const isHovered = hoveredChip === p.id;
    const details = connectionDetails?.[p.id];
    const handle = details?.screen_name || details?.page_name || details?.urn;

    const chipStyle: React.CSSProperties = {
      display: "flex",
      alignItems: "center",
      gap: 9,
      padding: "7px 14px 7px 10px",
      borderRadius: 99,
      border: isConnected
        ? `1.5px solid ${p.brandColor}`
        : "1.5px dashed rgba(255,255,255,0.18)",
      background: isConnected
        ? isHovered ? `${p.brandColor}25` : `${p.brandColor}18`
        : isHovered ? "rgba(255,255,255,0.05)" : "rgba(255,255,255,0.02)",
      fontSize: 12,
      fontWeight: 600,
      color: isConnected ? "#E8EAF0" : "rgba(255,255,255,0.7)",
      cursor: isConnecting ? "wait" : "pointer",
      transition: "all 0.18s ease",
      whiteSpace: "nowrap",
      transform: isHovered ? "translateY(-1px)" : "translateY(0)",
      boxShadow: isConnected && isHovered ? `0 4px 12px ${p.brandColor}30` : "none",
      userSelect: "none",
    };

    return (
      <Tooltip
        key={p.id}
        title={
          isConnected
            ? `${p.label}${handle ? ` (${handle})` : ""} — click to disconnect`
            : `Connect ${p.label} to enable posting`
        }
        arrow
      >
        <div
          style={chipStyle}
          onClick={() => {
            if (isConnecting) return;

            // Allow LinkedIn and facebook
            //const allowedPlatforms = ["linkedin", "facebook", "youtube"];
            const allowedPlatforms = ["linkedin", "youtube"];

            if (!allowedPlatforms.includes(p.id)) {
              setComingSoonPlatform(p.label);
              setComingSoonOpen(true);
              return;
            }

            if (isConnected) handleDisconnect(p.id);
            else handleConnect(p.id);
          }}
          onMouseEnter={() => setHoveredChip(p.id)}
          onMouseLeave={() => setHoveredChip(null)}
        >
          {isConnecting ? (
            <CircularProgress size={16} sx={{ color: p.brandColor, flexShrink: 0 }} />
          ) : isConnected ? (
            <CheckCircleIcon
              sx={{
                fontSize: 18,
                color: isHovered ? "#ef4444" : "#22C55E",
                transition: "color 0.18s ease",
                flexShrink: 0,
              }}
            />
          ) : (
            <AddCircleOutlineIcon
              sx={{
                fontSize: 18,
                color: "rgba(255,255,255,0.5)",
                flexShrink: 0,
              }}
            />
          )}

          <span style={{ color: p.brandColor, display: "flex", alignItems: "center", flexShrink: 0 }}>
            {p.icon}
          </span>

          <span>{p.shortLabel}</span>

          <span
            style={{
              fontSize: 10,
              fontWeight: 700,
              letterSpacing: "0.04em",
              color: isConnecting
                ? "rgba(255,255,255,0.55)"
                : isConnected
                  ? isHovered ? "#ef4444" : "#22C55E"
                  : "rgba(255,255,255,0.5)",
              transition: "color 0.18s ease",
              textTransform: "uppercase",
            }}
          >
            {isConnecting
              ? "Connecting…"
              : isConnected
                ? isHovered ? "Disconnect" : "Connected"
                : "Connect"}
          </span>
        </div>
      </Tooltip>
    );
  };

  // ==========================================================================
  // EARLY EXIT — show a redirect spinner while bouncing back to the origin page
  // ==========================================================================
  if (oauthRedirecting) {
    return (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "100vh",
          background: "transparent",
          color: "#fff",
          gap: 2,
        }}
      >
        <CircularProgress sx={{ color: "#4BA5EB" }} />
        <Typography sx={{ fontSize: 14, color: "rgba(255,255,255,0.7)" }}>
          Redirecting…
        </Typography>
      </Box>
    );
  }

  // ==========================================================================
  // NORMAL RENDER
  // ==========================================================================
  return (
    <Box sx={{ display: "flex", minHeight: "100vh", background: "transparent", color: "#fff", fontFamily: "'Inter', -apple-system, sans-serif" }}>
      <Box sx={{ flex: 1, overflowY: "auto" }}>

        <Box sx={{ px: "24px", pt: "24px" }}>
          <Typography sx={{ fontSize: "22px", fontWeight: 600, mb: "4px", color: "#fff" }}>Social Post</Typography>
          <Typography sx={{ color: "#969992", fontSize: "13px" }}>Manage and schedule your social media posts.</Typography>
        </Box>

        <Box sx={{ px: "24px", py: "24px" }}>

          {/* Header row */}
          <Stack direction="row" justifyContent="space-between" alignItems="center" mb="24px" flexWrap="wrap" gap={2}>
            <Stack direction="row" alignItems="center" spacing={1.25} flexWrap="wrap" rowGap={1}>
              <Typography
                sx={{
                  fontSize: 11,
                  fontWeight: 700,
                  letterSpacing: "0.06em",
                  color: "rgba(255,255,255,0.5)",
                  textTransform: "uppercase",
                  mr: 0.5,
                }}
              >
                Connections:
              </Typography>
              {CONNECTABLE_PLATFORMS.map(renderConnectChip)}
            </Stack>

            {/* <Tooltip title={!isAnyConnected ? "Please connect a social account first" : ""} arrow>
              <span>
                <Box
                  onClick={() => {
                    if (!isAnyConnected) return;
                    setIsEditMode(false); setEditingPostId(null); setExistingImage(null);
                    setPostData({ content: "", url: "", video_url: "", scheduleTime: "", platforms: { linkedin: false, twitter: false, facebook: false }, imageFile: null });
                    setOpenModal(true);
                  }}
                  sx={{
                    display: "inline-flex", alignItems: "center", gap: "6px", px: "40px", py: "10px", borderRadius: "8px",
                    background: !isAnyConnected ? "transparent" : "linear-gradient(90deg, #0168B5 0%, #4BA5EB 100%)",
                    border: !isAnyConnected ? "1px solid rgba(255,255,255,0.15)" : "none",
                    cursor: !isAnyConnected ? "not-allowed" : "pointer", color: "#fff",
                    opacity: !isAnyConnected ? 0.6 : 1,
                    "&:hover": { background: !isAnyConnected ? "transparent" : "linear-gradient(90deg, #0168B5 0%, #4BA5EB 100%)" },
                    transition: "all 0.2s ease",
                  }}
                >
                  <Typography sx={{ fontSize: "13px", fontWeight: 600, color: "#fff", userSelect: "none" }}>+ Create New Post</Typography>
                </Box>
              </span>
            </Tooltip> */}
          </Stack>

          {/* Stats */}
          <Typography sx={{ fontSize: "14px", fontWeight: 600, mb: "12px", color: "#fff" }}>Social Post Performance</Typography>
          <Stack direction="row" spacing="12px" mb="32px">
            {[{ label: "Posts", value: stats.total, sub: "Total Posts" }, { label: "Published", value: stats.published, sub: "Published Posts" }, { label: "Pending", value: stats.pending, sub: "Pending Posts" }].map((stat) => (
              <Box key={stat.label} sx={{ flex: 1, background: "transparent", borderRadius: "10px", border: "1px solid rgba(255,255,255,0.07)", px: "24px", py: "20px" }}>
                <Typography sx={{ color: "#fff", fontSize: "13px", mb: "8px" }}>{stat.label}</Typography>
                <Typography sx={{ fontSize: "34px", fontWeight: 700, lineHeight: 1, mb: "6px", color: "#fff" }}>{stat.value}</Typography>
                <Typography sx={{ color: "#9ca3af", fontSize: "12px" }}>{stat.sub}</Typography>
              </Box>
            ))}
          </Stack>

          {/* Posts list */}
          <Stack direction="row" alignItems="center" spacing="10px" mb="16px" flexWrap="wrap">
            <Typography sx={{ fontSize: "15px", fontWeight: 600, whiteSpace: "nowrap", flexShrink: 0, color: "#fff" }}>Social Posts</Typography>
            <Stack direction="row" alignItems="center" spacing="6px" sx={{ flex: 1, background: "transparent", border: "1px solid rgba(255,255,255,0.08)", borderRadius: "8px", px: "10px", py: "8px", minWidth: 200 }}>
              <SearchIcon sx={{ fontSize: 15, color: "rgba(255,255,255,0.3)", flexShrink: 0 }} />
              <input type="text" value={search} onChange={(e) => { setSearch(e.target.value); setPage(1); }} placeholder="Search..."
                style={{ background: "transparent", border: "none", outline: "none", color: "#fff", fontSize: "13px", width: "100%" }} />
            </Stack>
            <Stack direction="row" alignItems="center" spacing="6px" sx={{ flexShrink: 0 }}>
              <Typography sx={{ fontSize: "13px", color: "#fff", whiteSpace: "nowrap" }}>Views:</Typography>
              <Stack direction="row" alignItems="center" spacing="4px" onClick={(e) => setAnchorEl(e.currentTarget)}
                sx={{ background: "transparent", border: "1px solid rgba(255,255,255,0.08)", borderRadius: "8px", px: "10px", py: "7px", cursor: "pointer" }}>
                <Typography sx={{ fontSize: "13px", color: "#fff" }}>{filter.charAt(0).toUpperCase() + filter.slice(1)}</Typography>
                <KeyboardArrowDownIcon sx={{ fontSize: 16, color: "rgba(255,255,255,0.4)" }} />
              </Stack>
              <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
                {["all", "pending", "published"].map((item) => (
                  <MenuItem key={item} onClick={() => { setFilter(item); setPage(1); setAnchorEl(null); }}>{item.charAt(0).toUpperCase() + item.slice(1)}</MenuItem>
                ))}
              </Menu>
            </Stack>
            <Stack direction="row" alignItems="center" spacing="5px" sx={{ flexShrink: 0, background: "transparent", border: "1px solid rgba(255,255,255,0.08)", borderRadius: "8px", px: "10px", py: "7px", cursor: "pointer", "&:hover": { background: "transparent" } }}>
              <FilterListIcon sx={{ fontSize: 15, color: "rgba(255,255,255,0.45)" }} />
              <Typography sx={{ fontSize: "13px", color: "#fff" }}>Filters</Typography>
            </Stack>
          </Stack>

          {loading && <Typography sx={{ color: "#888", textAlign: "center", mt: 4 }}>Loading posts...</Typography>}
          {!loading && posts.length === 0 && <Typography sx={{ color: "#888", textAlign: "center", mt: 4 }}>No posts found</Typography>}

          {posts.length > 0 && (
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              mb={2}
            >
              <Button
                size="small"
                variant="outlined"
                onClick={handleSelectAllPosts}
                sx={{
                  color: "#4BA5EB",
                  borderColor: "#4BA5EB",
                }}
              >
                {allSelected
                  ? "Unselect All"
                  : "Select All"}
              </Button>


              <Button
                size="small"
                color="error"
                variant="contained"
                disabled={selectedPosts.length === 0 || isBulkDeleting}
                onClick={() => setBulkDeleteModal(true)}
              >
                Delete Selected ({selectedPosts.length})
              </Button>

            </Stack>
          )}

          <Stack spacing="12px">
            {posts.map((post) => {
              // Determine the correct status: if published_at exists, consider it published
              const isPublished = !!(post.published_at || post.status === "published");
              const displayStatus = isPublished ? "published" : (post.status === "pending" ? "pending" : "unknown");

              return (
                <Box key={post.id} sx={{ position: "relative", background: "transparent", borderRadius: "12px", border: "1px solid rgba(255,255,255,0.07)", p: "16px" }}>
                  <Box
                    sx={{
                      position: "absolute",
                      top: 8,
                      left: 8,
                      zIndex: 10,
                      background: "rgba(0,0,0,0.7)",
                      borderRadius: "50%",
                    }}
                  >
                    <Checkbox
                      checked={selectedPosts.includes(
                        post._id || post.id
                      )}
                      onChange={(e) => {
                        const id = post._id || post.id;

                        if (e.target.checked) {
                          setSelectedPosts((prev) => [
                            ...prev,
                            id,
                          ]);
                        } else {
                          setSelectedPosts((prev) =>
                            prev.filter((p) => p !== id)
                          );
                        }
                      }}
                      sx={{
                        color: "#fff",
                        "&.Mui-checked": {
                          color: "#4BA5EB",
                        },
                      }}
                    />
                  </Box>
                  <Stack direction={isMobile ? "column" : "row"} spacing="16px" alignItems="flex-start">
                    <Box component="img" /* src={post.image_url || "https://picsum.photos/400/200"} */ src={
                      post.image_url
                        ? /^(https?:)?\/\//i.test(post.image_url)
                          ? post.image_url
                          : `${process.env.REACT_APP_RETURN_DOMAIN_NAME}${post.image_url.startsWith("/") ? "" : "/"
                          }${post.image_url}`
                        : "https://picsum.photos/400/200"
                    } alt={post.content}
                      sx={{ width: isMobile ? "100%" : 196, height: 155, borderRadius: "8px", objectFit: "cover", flexShrink: 0 }} />

                    <Box flex={1} minWidth={0} sx={{ position: 'relative' }}>
                      <Box sx={{ position: 'absolute', top: -10, right: 4, display: 'flex', gap: '6px', alignItems: 'center', zIndex: 1 }}>
                        {/* <Tooltip title="View Post">
                        <IconButton size="small" onClick={() => handleViewClick(post)}
                          sx={{ color: '#9ca3af', border: '1px solid #30363d', borderRadius: '6px', padding: '4px', '&:hover': { color: '#3b82f6', borderColor: '#3b82f6', backgroundColor: 'rgba(59,130,246,0.1)' } }}>
                          <VisibilityOutlinedIcon sx={{ fontSize: '16px' }} />
                        </IconButton>
                      </Tooltip> */}
                        {/* <Tooltip title="View Post">
                        <IconButton size="small" onClick={() => {
                          navigate('/codegenie/generated-blogs', {
                            state: {
                              activeItem: 'socailpost',
                              scrollToTitle: post.content?.substring(0, 60) || '',
                            },
                          });
                        }}
                          sx={{ color: '#9ca3af', border: '1px solid #30363d', borderRadius: '6px', padding: '4px', '&:hover': { color: '#3b82f6', borderColor: '#3b82f6', backgroundColor: 'rgba(59,130,246,0.1)' } }}>
                          <VisibilityOutlinedIcon sx={{ fontSize: '16px' }} />
                        </IconButton>
                      </Tooltip> */}
                        <Tooltip title="Edit Post">
                          <IconButton size="small" onClick={() => handlePublishIconClick(post)} disabled={!!isPublishLoading[post.id]} /* onClick={() => handleEditClick(post)} */
                            sx={{ color: '#9ca3af', border: '1px solid #30363d', borderRadius: '6px', padding: '4px', '&:hover': { color: '#3b82f6', borderColor: '#3b82f6', backgroundColor: 'rgba(59,130,246,0.1)' } }}>
                            <EditOutlinedIcon sx={{ fontSize: '16px' }} />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Delete Post">
                          <IconButton size="small" onClick={() => handleDeleteClick(post._id || post.id)}
                            sx={{ color: '#9ca3af', border: '1px solid #30363d', borderRadius: '6px', padding: '4px', '&:hover': { color: '#ef4444', borderColor: '#ef4444', backgroundColor: 'rgba(239,68,68,0.1)' } }}>
                            <DeleteOutlineIcon sx={{ fontSize: '16px' }} />
                          </IconButton>
                        </Tooltip>

                        {post.platform === "twitter" && !isPublished && (
                          <Tooltip title="Publish Tweet Now">
                            <IconButton
                              size="small"
                              onClick={() => handlePublishTwitterNow(post)}
                              disabled={!!isTwitterPublishLoading[post.id]}
                              sx={{
                                color: '#9ca3af',
                                border: '1px solid #30363d',
                                borderRadius: '6px',
                                padding: '4px',
                                '&:hover': {
                                  color: '#1DA1F2',
                                  borderColor: '#1DA1F2',
                                  backgroundColor: 'rgba(29,161,242,0.1)',
                                },
                              }}
                            >
                              {isTwitterPublishLoading[post.id] ? (
                                <CircularProgress size={14} sx={{ color: '#1DA1F2' }} />
                              ) : (
                                <RocketLaunchOutlinedIcon sx={{ fontSize: '16px' }} />
                              )}
                            </IconButton>
                          </Tooltip>
                        )}

                        <Tooltip title="Generate Post / Publish Schedule">
                          <IconButton size="small" onClick={() => handlePublishIconClick(post)} disabled={!!isPublishLoading[post.id]}
                            sx={{ color: '#9ca3af', border: '1px solid #30363d', borderRadius: '6px', padding: '4px', '&:hover': { color: '#10b981', borderColor: '#10b981', backgroundColor: 'rgba(16,185,129,0.1)' } }}>
                            {isPublishLoading[post.id] ? <CircularProgress size={14} sx={{ color: '#4BA5EB' }} /> : <PublishIcon sx={{ fontSize: '16px' }} />}
                          </IconButton>
                        </Tooltip>
                      </Box>

                      <Stack direction="row" justifyContent="space-between" alignItems="flex-start">
                        <Box flex={1} pr="8px">
                          <Typography sx={{ color: "#9ca3af", fontSize: "10.5px", fontWeight: 500, letterSpacing: "0.5px", mb: "4px" }}>{formatToLocal(post.schedule_time) || <br />}</Typography>
                          <Typography sx={{ fontSize: "14.5px", fontWeight: 500, lineHeight: 1.4, mb: "4px", color: "#fff" }}>{post.content}</Typography>
                          {post.subtitle && <Typography sx={{ color: "#9ca3af", fontSize: "12.5px", mb: "6px" }}>{post.subtitle}</Typography>}
                        </Box>
                      </Stack>

                      <Box sx={{ mt: "8px", mb: "10px" }}><PlatformChip platform={post.platform} /></Box>

                      {!isPublished ? (
                        <Stack direction="row" alignItems="center" spacing="12px" flexWrap="wrap">
                          <Stack direction="row" alignItems="center" spacing="6px" sx={{ px: "10px", py: "4px", borderRadius: "7px", background: "transparent", border: "1px solid rgba(255,255,255,0.08)" }}>
                            <AccessTimeOutlinedIcon sx={{ fontSize: 13, color: "rgba(255,255,255,0.5)" }} />
                            <Typography sx={{ color: "rgba(255,255,255,0.5)", fontSize: "12px" }}>Scheduled {formatToLocal(post.schedule_time)}</Typography>
                          </Stack>
                          {/* Post not Published status badge */}
                          <Stack direction="row" alignItems="center" spacing="4px" sx={{ px: "10px", py: "4px", borderRadius: "7px", background: "transparent", border: "1px solid rgba(239,68,68,0.3)" }}>
                            <Box sx={{ width: 7, height: 7, borderRadius: '50%', background: '#ef4444', flexShrink: 0 }} />
                            <Typography sx={{ color: "#ef4444", fontSize: "12px", fontWeight: 500 }}>Post not Published</Typography>
                          </Stack>
                          <Button
                            variant="outlined"
                            size="small"
                            onClick={() => handleEditClick(post)}
                            sx={{ borderColor: "rgba(255,255,255,0.14)", color: "rgba(255,255,255,0.5)", textTransform: "none", borderRadius: "7px", fontSize: "12px", py: "3px", "&:hover": { borderColor: "#4BA5EB", color: "#4BA5EB" } }}
                          >
                            Reschedule
                          </Button>
                        </Stack>
                      ) : (
                        <Stack direction="row" alignItems="center" spacing="12px" flexWrap="wrap">
                          {/* Platform Logo for Published Posts */}
                          <Box sx={{ display: "flex", alignItems: "center", gap: "6px", px: "10px", py: "4px", borderRadius: "7px", background: "transparent", border: "1px solid rgba(255,255,255,0.08)" }}>
                            {post.platform === "linkedin" && <LinkedInIcon sx={{ fontSize: 16, color: "#0A66C2" }} />}
                            {post.platform === "twitter" && <TwitterIcon sx={{ fontSize: 16, color: "#1DA1F2" }} />}
                            {post.platform === "facebook" && <FacebookIcon sx={{ fontSize: 16, color: "#1877F2" }} />}
                            {post.platform === "youtube" && <YouTubeIcon sx={{ fontSize: 16, color: "#FF0000" }} />}
                            <Typography sx={{ color: "#4BA5EB", fontSize: "12px", fontWeight: 500 }}>Published on {post.platform}</Typography>
                          </Box>
                          {/* Published green badge */}
                          <Stack direction="row" alignItems="center" spacing="4px" sx={{ px: "10px", py: "4px", borderRadius: "7px", background: "transparent", border: "1px solid rgba(16,185,129,0.3)" }}>
                            <Box sx={{ width: 7, height: 7, borderRadius: '50%', background: '#10b981', flexShrink: 0 }} />
                            <Typography sx={{ color: "#10b981", fontSize: "12px", fontWeight: 500 }}>Published</Typography>
                          </Stack>
                        </Stack>
                      )}
                    </Box>
                  </Stack>
                </Box>
              )
            })}
          </Stack>

          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mt: 3 }}>
            <Typography sx={{ fontSize: "12px", color: "#aaa" }}>Total Posts: {stats.total}</Typography>
            <Typography sx={{ fontSize: "12px", color: "#aaa" }}>Page {page} of {Math.ceil(total / limit) || 1} </Typography>
            <Stack direction="row" spacing={1}>
              <Button disabled={page === 1} onClick={() => setPage(page - 1)} sx={{ color: "#fff" }}>Prev</Button>
              <Button disabled={page * limit >= total} onClick={() => setPage(page + 1)} sx={{ color: "#fff" }}>Next</Button>
            </Stack>
          </Box>

        </Box>
      </Box>

      {/* ════════ CREATE / EDIT MODAL ════════ */}
      <Dialog
        open={openModal}
        onClose={() => setOpenModal(false)}
        maxWidth="sm"
        fullWidth
        sx={{ "& .MuiDialog-container": { alignItems: "center", justifyContent: "center" }, "& .MuiDialog-paper": { mx: "auto" } }}
        PaperProps={{ sx: { borderRadius: "18px", background: "rgb(245,246,250)", boxShadow: "0 0 0 1px rgba(75,165,235,0.15), 0 0 40px rgba(75,165,235,0.15)" } }}
      >
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", px: 3, pt: 3, pb: 0 }}>
          <Typography sx={{ fontSize: 18, fontWeight: 600, color: "#000" }}>{isEditMode ? "Edit Post" : "Schedule New Post"}</Typography>
          <IconButton onClick={() => { setIsEditMode(false); setEditingPostId(null); setExistingImage(null); setPostData({ content: "", url: "", video_url: "", scheduleTime: "", platforms: { linkedin: false, twitter: false, facebook: false }, imageFile: null }); setOpenModal(false); }} sx={{ color: "#888", "&:hover": { color: "#000" } }}>
            <CloseIcon />
          </IconButton>
        </Box>

        <DialogContent sx={{ background: "rgb(245,246,250)", px: 3, pt: 2, pb: 3 }}>
          <Box sx={{ height: "1px", background: "linear-gradient(90deg, transparent, rgba(75,165,235,0.5), transparent)", mb: 2.5 }} />
          <Stack spacing={2}>

            <Box sx={{ position: "relative" }}>
              <Typography sx={fieldLabelStyle}>
                What's on your mind?
                {postData.platforms.twitter && (
                  <span style={{ color: postData.content.length > 280 ? "#d32f2f" : "#666", fontWeight: 400, marginLeft: 8 }}>
                    {postData.content.length}/280 {postData.content.length > 280 ? "(will be auto-threaded)" : ""}
                  </span>
                )}
              </Typography>
              <TextField fullWidth multiline rows={4} placeholder="What's on your mind..." value={postData.content}
                onChange={(e) => setPostData({ ...postData, content: e.target.value })} sx={inputStyle} />
              <IconButton onClick={() => handleMic(recognitionRef, isListening, setIsListening)}
                sx={{ position: "absolute", bottom: "10px", right: "10px", zIndex: 1, animation: isListening ? "pulse 1s infinite" : "none", "@keyframes pulse": { "0%": { transform: "scale(1)" }, "50%": { transform: "scale(1.1)" }, "100%": { transform: "scale(1)" } } }}>
                <MicNoneOutlinedIcon sx={{ color: isListening ? "red" : "#888" }} />
              </IconButton>
            </Box>

            <Box>
              <Typography sx={fieldLabelStyle}>URL <span style={{ color: '#666', fontWeight: 400 }}>(optional) — Paste a blog/article link</span></Typography>
              <TextField fullWidth placeholder="https://example.com" value={postData.url}
                onChange={(e) => setPostData({ ...postData, url: e.target.value })} sx={inputStyle} />
            </Box>

            <Box>
              <Typography sx={fieldLabelStyle}>Platforms to Schedule</Typography>
              <Stack direction="row" spacing={2} flexWrap="wrap">
                {["linkedin", "twitter", "facebook"].map((p) => {
                  const isDisabled = disabledPlatforms.includes(p);
                  // In edit mode, keep the already-saved platform enabled even if not currently connected
                  const isCurrentPlatform = isEditMode && postData.platforms[p as keyof typeof postData.platforms];
                  const notConnected = !authStatus?.[p] && !isCurrentPlatform;
                  return (
                    <Tooltip
                      key={p}
                      title={isDisabled ? "Not enabled" : notConnected ? `Connect ${p} first` : ""}
                      arrow
                    >
                      <span>
                        <FormControlLabel
                          control={
                            <Checkbox
                              disabled={isDisabled || notConnected}
                              sx={{ color: "#888", "&.Mui-checked": { color: "#4BA5EB" } }}
                              checked={postData.platforms[p as keyof typeof postData.platforms]}
                              onChange={(e) =>
                                setPostData({
                                  ...postData,
                                  platforms: { ...postData.platforms, [p]: e.target.checked },
                                })
                              }
                            />
                          }
                          label={
                            <Typography sx={{ color: isDisabled || notConnected ? "#999" : "#000", fontSize: "13px" }}>
                              {p}
                            </Typography>
                          }
                        />
                      </span>
                    </Tooltip>
                  );
                })}
              </Stack>
            </Box>

            <Box>
              <Typography sx={fieldLabelStyle}>
                Schedule Time
                {postData.platforms.twitter &&
                  Object.values(postData.platforms).filter(Boolean).length === 1 && (
                    <span style={{ color: "#666", fontWeight: 400, marginLeft: 6 }}>
                      (leave empty to publish immediately)
                    </span>
                  )}
              </Typography>
              <TextField type="datetime-local" fullWidth value={postData.scheduleTime}
                onChange={(e) => setPostData({ ...postData, scheduleTime: e.target.value })}
                InputProps={{ startAdornment: <AccessTimeOutlinedIcon sx={{ color: "#4BA5EB", mr: 1, fontSize: 22 }} /> }}
                sx={{
                  "& input[type='datetime-local']::-webkit-calendar-picker-indicator": { filter: "brightness(0) saturate(100%) invert(0%)", cursor: "pointer", opacity: "1 !important", display: "block", width: "18px", height: "18px" },
                  "& .MuiOutlinedInput-root": { background: "transparent", borderRadius: "10px", "& fieldset": { borderColor: "rgba(0,0,0,0.15)" }, "&:hover fieldset": { borderColor: "#4BA5EB" }, "&.Mui-focused fieldset": { borderColor: "#4BA5EB" } },
                  "& input": { color: '#000', fontSize: "13px" },
                }}
              />
            </Box>

            <Box>
              <Typography sx={fieldLabelStyle}>Image <span style={{ color: "rgba(0,0,0,0.4)", fontWeight: 400 }}>(optional)</span></Typography>
              <Box sx={{ display: "flex", alignItems: "center", gap: "16px", p: "12px", borderRadius: "10px", background: "transparent", border: "1px solid rgba(0,0,0,0.08)" }}>
                {existingImage && (
                  <Box component="img" src={normalizeImageUrl(existingImage)}
                    sx={{ width: 90, height: 70, objectFit: "cover", borderRadius: "8px", border: "1px solid rgba(0,0,0,0.1)", flexShrink: 0 }} />
                )}
                <Box sx={{ flex: 1 }}>
                  <Button variant="outlined" component="label"
                    sx={{ borderRadius: "8px", color: "#4BA5EB", textTransform: "none", fontSize: "12px", px: "14px", py: "6px", border: '1px solid #4BA5EB !important', "&:hover": { borderColor: "#4BA5EB", background: "transparent" } }}>
                    Upload Image
                    <input hidden type="file" onChange={(e) => {
                      const file = e.target.files?.[0] || null;
                      setPostData({ ...postData, imageFile: file });
                      if (file) setExistingImage(URL.createObjectURL(file));
                    }} />
                  </Button>
                </Box>
              </Box>
            </Box>

          </Stack>

          <Button fullWidth onClick={handleSubmitPost}
            sx={{ mt: 3, background: "linear-gradient(135deg, #0168B5, #4BA5EB)", color: "#fff", py: 1.6, fontWeight: 600, borderRadius: "10px", boxShadow: "0 10px 25px rgba(75,165,235,0.35)", "&:hover": { background: "linear-gradient(135deg, #015a9c, #3c90d1)", transform: "translateY(-1px)" }, transition: "all 0.2s ease" }}>
            {isEditMode
              ? "Update Post"
              : postData.platforms.twitter &&
                Object.values(postData.platforms).filter(Boolean).length === 1 &&
                !postData.scheduleTime
                ? "Publish Tweet Now"
                : "Schedule Post"}
          </Button>
        </DialogContent>
      </Dialog>

      <ComingSoonPopup
        open={comingSoonOpen}
        onClose={() => setComingSoonOpen(false)}
        title="Coming Soon"
        description={`${comingSoonPlatform} feature is almost ready. We're putting on the finishing touches — stay tuned!`}
      />

      <Modal
        open={bulkDeleteModal}
        onClose={() => setBulkDeleteModal(false)}
        disableEscapeKeyDown
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <Box
          sx={{
            position: "absolute" as "absolute",
            top: "50%",
            left: "50%",
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            transform: "translate(-50%, -50%)",
            width: isMobile ? "95%" : "40%",
            bgcolor: "background.paper",
            border: "2px solid #000",
            boxShadow: 24,
            pt: 2,
            px: 4,
            pb: 3,
            borderRadius: '15px',
            padding: '3%'
          }}
        >
          <Typography variant="h6" mb={2}>
            Delete Posts
          </Typography>

          <Typography mb={3}>
            Are you sure you want to delete
            <strong> {selectedPosts.length} </strong>
            selected post(s)?
            This action cannot be undone.
          </Typography>

          <Stack direction="row" spacing={2} justifyContent="flex-end">
            <Button
              variant="outlined"
              onClick={() => setBulkDeleteModal(false)}
            >
              Cancel
            </Button>

            <Button
              variant="contained"
              color="error"
              onClick={async () => {
                await handleBulkDeletePosts();
                setBulkDeleteModal(false);
              }}
            >
              Delete Selected
            </Button>
          </Stack>
        </Box>
      </Modal>

    </Box>
  );
};

export default SocialPost;